/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DataSourcePrioritiesEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>, // oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const dataSourcePrioritiesEntryPoint: EntryPoint<
	DataSourcePrioritiesEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<DataSourcePrioritiesEntryPointComponent>(
		/* webpackChunkName: "async-data-source-priorities" */ './DataSourcePrioritiesPage.tsx',
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
